// extracted by mini-css-extract-plugin
module.exports = {"container":"HotelPreOpening_container__dCFJb","date":"HotelPreOpening_date__niRCH","contact":"HotelPreOpening_contact__uAOo0"};